import { Modal } from '@polichat/flamboyant';
import { useOverdueCustomer } from 'src/contexts/OverdueCustomerContext';
import { OverdueCustomerContent } from './OverdueCustomerContent';

export const OverdueCustomerModal = () => {
  const { showOverdueCustomerModal, setShowOverdueCustomerModal, hasDebt } =
    useOverdueCustomer();

  return (
    <Modal
      isOpen={showOverdueCustomerModal}
      className="over-due-modal"
      toggle={() => {
        if (hasDebt) {
          setShowOverdueCustomerModal(false);
        }
      }}
    >
      <OverdueCustomerContent />
    </Modal>
  );
};
